import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import {
  EnergyUsageGranularity,
  EnergyUsageResponse,
} from "@/api/backofficeRest/generated/model"
import { IEnergyUsage } from "@/models/energyUsage/energyUsage.types"
import { EnergyUsageParser } from "@/models/energyUsage/energyUsage.parser"

class EnergyUsageServiceClass {
  getUsage(
    accountId: number | null,
    fromDate: string,
    toDate: string,
    granularity: EnergyUsageGranularity,
  ): QueryResult<IEnergyUsage[] | null> {
    return useQuery({
      ...BackofficeRestQueries.account.energyUsage(
        accountId ?? -1,
        fromDate,
        toDate,
        granularity,
      ),
      placeholderData: null,
      useRawResponse: true,
      enabled: !!accountId,
      parserFn: (rawData: EnergyUsageResponse) =>
        (rawData ?? []).map(EnergyUsageParser.toDomain),
    })
  }

  getDailyUsage(
    accountId: number | null,
    fromDate: string,
    toDate: string,
  ): QueryResult<IEnergyUsage[] | null> {
    return this.getUsage(
      accountId,
      fromDate,
      toDate,
      EnergyUsageGranularity.DAY,
    )
  }

  getHalfHourlyUsage(
    accountId: number | null,
    fromDate: string,
    toDate: string,
  ): QueryResult<IEnergyUsage[] | null> {
    return this.getUsage(accountId, fromDate, toDate, EnergyUsageGranularity.HH)
  }
}

export const EnergyUsageService = new EnergyUsageServiceClass()
